import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Form from "../../common/Form";
import Row from "../../common/Row";
import TextInput from "../../common/TextInput";
import NumberInput from "../../common/NumberInput";
import { KostenTypes, KostenOpbrengstenInvesteringMainTypes, KostOpbrengst, OpbrengstenTypes } from "../../../constants/DomainConstants";
import SelectInput from "../../common/SelectInput";
import Button from "../../common/Button";

const KostOpbrengstEditForm = (props) => {
    const {
        model,
        color,
        okiTypes,
        disabled,
        onBewaarClick,
        onSluitClick,
        onChange,
        validationMessages,
        type,
        okPosten,
        onKopieBedragNaarAndereJaren,
        validationMessageType
    } = props;

    let total = 0;
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].forEach(i => total += model[`bedragJaar${i}`] ? parseInt(model[`bedragJaar${i}`] * 100) : 0);
    total = total / 100;

    const selectedOkiType = okiTypes.find(item => item.id === model.typeId);
    const subTypes = selectedOkiType ? selectedOkiType.subtypes.map(subtype => { return { label: subtype.titel, value: subtype.id }; }) : [];

    const isKost = type === KostOpbrengst.KOST;
    const kostenTypeValues = KostenTypes.map(type => type.value);
    const opbrengstenTypeValues = OpbrengstenTypes.map(type => type.value);
    const kostenopbrengstenposten = isKost ? okPosten.filter(post => kostenTypeValues.indexOf(post.type) > -1) : okPosten.filter(post => opbrengstenTypeValues.indexOf(post.type) > -1);
    const jaar1OvernemenButtonTekst = `${isKost ? "Kosten" : "Opbrengsten"} van jaar 1 overnemen voor alle jaren`;

    return (<Section title={"Vul onderstaande gegevens in"} color={color}>
        <Form
            title={isKost ? "Invulformulier kosten" : "Invulformulier opbrengsten"}
            name="invulformulierKosten"
            leftButtonLabel="Sluit"
            onLeftButtonClick={onSluitClick}
            rightButtonLabel="Bewaar"
            onRightButtonClick={onBewaarClick}
            rightButtonDisabled={disabled}
            isNotRequired
        >
            <Row>
                <SelectInput
                    label={isKost ? "Kostenpost" : "Opbrengstenpost"}
                    name="opbrengstenOfKostenPostId"
                    value={model.opbrengstenOfKostenPostId}
                    size={6}
                    items={kostenopbrengstenposten}
                    disabled={disabled}
                    validationMessage={validationMessages.opbrengstenOfKostenPostId}
                    validationMessageType={validationMessageType}
                    onChange={onChange}
                />
                {model.typeId === KostenOpbrengstenInvesteringMainTypes.Bedrijfskost || model.typeId === KostenOpbrengstenInvesteringMainTypes.Bedrijfsopbrengst ?
                    <SelectInput
                        label={isKost ? "Kostentype" : "Opbrengstentype"}
                        name="subtypeId"
                        value={model.subtypeId}
                        size={6}
                        items={subTypes}
                        validationMessage={validationMessages.subtypeId}
                        validationMessageType={validationMessageType}
                        onChange={onChange}
                        disabled
                    /> : null}
            </Row>
            <Row>
                <SelectInput
                    label={isKost ? "Kostensoort" : "Opbrengstensoort"}
                    name="typeId"
                    value={model.typeId}
                    size={6}
                    items={isKost ? KostenTypes : OpbrengstenTypes}
                    validationMessage={validationMessages.typeId}
                    validationMessageType={validationMessageType}
                    onChange={onChange}
                    disabled
                />
                <TextInput
                    label="Omschrijving"
                    name="omschrijving"
                    value={model.omschrijving}
                    size={6}
                    validationMessage={validationMessages.omschrijving}
                    validationMessageType={validationMessageType}
                    onChange={onChange}
                    disabled={disabled}
                    maxLength={40}
                />
            </Row>
            <Row>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i =>
                    <NumberInput
                        key={i}
                        label={`jaar ${i}`}
                        name={`bedragJaar${i}`}
                        onChange={onChange}
                        value={model[`bedragJaar${i}`]}
                        size={3}
                        validationMessage={validationMessages[`bedragJaar${i}`]}
                        validationMessageType={validationMessageType}
                        isValuta
                        disabled={disabled}
                    />
                )}
                <div className="o-col-6">
                    <Button style={{ marginRight: '0.8333%', width: '100%', height: '63px' }} className="o-col-12" onClick={onKopieBedragNaarAndereJaren} text={jaar1OvernemenButtonTekst} />
                </div>
            </Row>
            <Row>
                <NumberInput
                    label="Totaal"
                    name="totaal"
                    value={total}
                    size={3}
                    readOnly
                    disabled={disabled}
                    isValuta
                />
            </Row>
        </Form>
    </Section>);
};

KostOpbrengstEditForm.defaultProps = {
    validationMessages: {},
    kostensoorten: [],
    kostenposten: [],
    okiTypes: []
};

KostOpbrengstEditForm.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    okiTypes: PropTypes.array,
    kostensoorten: PropTypes.array,
    kostenposten: PropTypes.array,
    model: PropTypes.object,
    validationMessages: PropTypes.object,
    onBewaarClick: PropTypes.func.isRequired,
    onSluitClick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    type: PropTypes.number.isRequired,
    okPosten: PropTypes.array,
    onKopieBedragNaarAndereJaren: PropTypes.func,
    validationMessageType: PropTypes.string
};

export default KostOpbrengstEditForm;